import { DashboardQueryParams, StickerParams } from "../../../phases";
import { IWorkDetailRequestBody } from "@baseTypes/service/dashboard/IWorksDashboardService";

export const getWorkDetailsRequestParams = (
    dashParams: DashboardQueryParams,
    { workId, planFrom, planTo, factFrom, factTo, cropRotationIds, geoZoneCultivationInfo, date }: StickerParams
): IWorkDetailRequestBody => {
    return {
        tzOffset: new Date().getTimezoneOffset(),
        operationId: Number(workId),
        cropRotationIds: cropRotationIds,
        date: Number(date) || dashParams.date,
        period: {
            plan: {
                from: Number(planFrom),
                to: Number(planTo)
            },
            fact: {
                from: Number(factFrom),
                to: Number(factTo)
            }
        },
        geoZoneCultivationInfo: JSON.parse(geoZoneCultivationInfo)
    }
}